import { Link, NavLink } from 'react-router-dom';
import { Container } from '@/components/ui/Container';
import { headerConfig, siteConfig } from '@/data/site';

export const Header = () => (
  <header className="site-header">
    <Container>
      <div className="site-header__inner">
        <Link to="/" className="brand-mark">
          {headerConfig.logoUrl
            ? <img src={headerConfig.logoUrl} alt={siteConfig.name} className="brand-mark__logo" />
            : (
              <>
                <span className="brand-mark__eyebrow">PublishWeaver</span>
                <span className="brand-mark__title">Blog</span>
              </>
            )
          }
        </Link>

        <nav className="site-nav" aria-label="Primary">
          {siteConfig.nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => (isActive ? 'site-nav__link is-active' : 'site-nav__link')}
            >
              {item.label}
            </NavLink>
          ))}
          <a href="https://www.publishweaver.com" className="site-nav__link" target="_blank" rel="noopener noreferrer">
            PublishWeaver
          </a>
        </nav>
      </div>
    </Container>
  </header>
);
